import { render, staticRenderFns } from "./StudentResponse.vue?vue&type=template&id=c7e56bea&scoped=true"
import script from "./StudentResponse.vue?vue&type=script&lang=js"
export * from "./StudentResponse.vue?vue&type=script&lang=js"
import style0 from "./StudentResponse.vue?vue&type=style&index=0&id=c7e56bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e56bea",
  null
  
)

export default component.exports